<template>
    <button class="button-simple" :style="defineStyle">
        <p>
            {{textButton}}
        </p>
    </button>
</template>
<script>
import {addAlpha} from '../../helpers/custom'
export default {
    props: {
        textButton : {
            type : String,
            required : true
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    data(){
        return{
            colors:{}
        }
    },    
    computed:{
        defineStyle(){
            // if(this.theme == 'dark')
            const backgroundColor = this.colors.secondary
            const boxShadowColor = '0px 5px 0px 0px' + addAlpha(this.colors.secondary, 0.5)
            return {
                'box-shadow': boxShadowColor,
                'background-color': backgroundColor,
                'color': '#fff'
            }
        },        
    }
}
</script>
<style lang="scss" scoped>
    .button-simple{
        padding: 23px 0px;
        border-radius: 30px;
        // background-color: #FFF581;
        display: flex;
        align-items: center;
        width: 100%;
        border: none;
        height: 45px;
        max-height: 45px;
        text-transform: uppercase;
        font-size: 15px;
        letter-spacing: 2px;
        font-weight: 900;
        // color: black;
        // border-top: 6px #FFF581 solid;
        // border-bottom: 6px #FFC483 solid;
        outline: none;
        vertical-align: middle;
        display: flex;
        justify-content: space-around;
        box-sizing: border-box;
        position: relative;
    }
</style>


